import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_payment_component_pay_now_validation_web",
  stages: {
    users_who_click_pay: 1,
    users_who_click_pay_with_pc_validation_error: 2,
    desktop: 3,
    mdot: 4
  },
  defaultStage: 1,
  goals: {
    click_pay_after_pc_validation_error: 1,
    has_validation_error: 2,
    verify_price_change_calls: 3
  },
  goalsWithValue: ["number_of_validation_attempts"] // Number of validation attempts before payment
});

const { stages, goals, goalsWithValue } = utils;

export const useTrackPaymentComponentValidation = () => {
  const { isDesktop, isMobile } = useProfiler();

  const trackClient = useCallback(() => {
    isDesktop() && stages.desktop();
    isMobile() && stages.mdot();
  }, [isDesktop, isMobile]);

  const trackClickPayWithPCValidationError = useCallback(() => {
    stages.users_who_click_pay_with_pc_validation_error();
  }, []);

  const trackPayAfterPaymentComponentError = useCallback(() => {
    goals.click_pay_after_pc_validation_error();
  }, []);

  const trackHadPCValidationError = useCallback(() => {
    goals.has_validation_error();
  }, []);

  const trackPCValidationAttempts = useCallback((attempts: number) => {
    goalsWithValue.number_of_validation_attempts(attempts);
  }, []);

  const trackVerifyPriceChangeCalls = useCallback(() => {
    goals.verify_price_change_calls();
  }, []);

  return {
    trackClient,
    trackClickPayWithPCValidationError,
    trackPayAfterPaymentComponentError,
    trackHadPCValidationError,
    trackPCValidationAttempts,
    trackVerifyPriceChangeCalls
  };
};

export default utils;
